import { date as commonDate } from '@finley-technologies/common';

import { TaskFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated.d';

export const taskStatuses = [
  'overdue',
  'dueSoon',
  'completed',
  'archived',
] as const; // this is no better way to write out the order of these four statuses (can't figure out a way to do this using the gql type)
export type TaskStatus = typeof taskStatuses[number];

export const getLoanIdFromCategorySpecificProperties = (
  props: TaskFragmentGQLType['domainProperties']['categorySpecificProperties'],
): string | undefined => {
  switch (props.__typename) {
    case 'FundingDisbursementTaskSpecificProperties':
      return props.fundingDisbursementLoanId;
    case 'PaymentInKindItemTaskSpecificProperties':
      return props.paymentInKindLoanId;
    case 'FundingRequestTaskSpecificProperties':
      return props.fundingRequestLoanId ?? undefined;
    case 'InvoiceTaskSpecificProperties':
      return props.invoiceLoanId ?? undefined;
    case 'LenderSharesTaskSpecificProperties':
      return props.lenderSharesLoanId;
    default:
      throw Error(
        `[Tasks] CategorySpecificPropertiesGQLType should always have a __typename`,
      );
  }
};

export const getActionRequiredFromCategorySpecificProperties = (
  props: TaskFragmentGQLType['domainProperties']['categorySpecificProperties'],
): string => {
  switch (props.__typename) {
    case 'FundingDisbursementTaskSpecificProperties':
      return 'Mark Disbursed';
    case 'PaymentInKindItemTaskSpecificProperties':
      return 'Mark Notified';
    case 'FundingRequestTaskSpecificProperties':
      return 'Approve';
    case 'InvoiceTaskSpecificProperties':
      return 'Mark Paid';
    case 'LenderSharesTaskSpecificProperties':
      return 'Mark Funded';
    default:
      throw Error(
        `[Tasks] CategorySpecificPropertiesGQLType should always have a __typename`,
      );
  }
};

export const getDueDateFromCategorySpecificProperties = (
  props: TaskFragmentGQLType['domainProperties']['categorySpecificProperties'],
): string | undefined => {
  switch (props.__typename) {
    case 'FundingDisbursementTaskSpecificProperties':
      return props.fundingDisbursementDueDate
        ? commonDate.fullDateStrToShortMonthDayYearString(
            commonDate.epochMsToFullDateStr(props.fundingDisbursementDueDate),
          )
        : undefined;
    case 'PaymentInKindItemTaskSpecificProperties':
      return props.paymentInKindDueDate
        ? commonDate.fullDateStrToShortMonthDayYearString(
            commonDate.epochMsToFullDateStr(props.paymentInKindDueDate),
          )
        : undefined;
    case 'FundingRequestTaskSpecificProperties':
      return commonDate.fullDateStrToShortMonthDayYearString(
        commonDate.epochMsToFullDateStr(props.fundingRequestDueDate),
      );
    case 'InvoiceTaskSpecificProperties':
      return commonDate.fullDateStrToShortMonthDayYearString(
        commonDate.epochMsToFullDateStr(props.invoiceDueDate),
      );
    case 'LenderSharesTaskSpecificProperties':
      return commonDate.fullDateStrToShortMonthDayYearString(
        commonDate.epochMsToFullDateStr(props.lenderSharesDueDate),
      );
    default:
      throw Error(
        `[Tasks] CategorySpecificPropertiesGQLType should always have a __typename`,
      );
  }
};
